export default __webpack_public_path__ + "cb908e4efe53c432fb4f1e8790aeaaef.jpeg";